import { render, staticRenderFns } from "./DataMigrationDialog.vue?vue&type=template&id=6709fe13&scoped=true"
import script from "./DataMigrationDialog.vue?vue&type=script&lang=js"
export * from "./DataMigrationDialog.vue?vue&type=script&lang=js"
import style0 from "./DataMigrationDialog.vue?vue&type=style&index=0&id=6709fe13&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6709fe13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6709fe13')) {
      api.createRecord('6709fe13', component.options)
    } else {
      api.reload('6709fe13', component.options)
    }
    module.hot.accept("./DataMigrationDialog.vue?vue&type=template&id=6709fe13&scoped=true", function () {
      api.rerender('6709fe13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/integralManage/record/dialogs/DataMigrationDialog.vue"
export default component.exports